export const GENERAL_FAQS = [
  {
    q: "What does Uhlumo Organics sell?",
    a: "Uhlumo Organics sources, packages, supplies and distributes natural wellness products. Our range includes Sea Moss Gel, Liquid Chlorophyll Drops, Shilajit-Infused Honey, Collagen Powder with Zinc and Vitamin C, and Hibiscus and Beetroot Juice.",
    link: { to: "/products", label: "Explore our products" },
  },
  {
    q: "Where is Uhlumo Organics located?",
    a: "We are based at NY 52, No. 39, Shiba Street, Gugulethu, Cape Town, 7750, in the Western Cape, South Africa.",
    link: { to: "/contact", label: "Contact details" },
  },
  {
    q: "Are your products natural?",
    a: "Our focus is natural wellness products. However, we do not describe products as certified organic, and not every product is plant-based — for example, collagen is commonly derived from animal sources. Verified ingredient information for each product will be published from its label.",
    link: { to: "/products", label: "View product information" },
  },
  {
    q: "How can I place an order?",
    a: "Orders are currently handled by enquiry. Send us an enquiry form or WhatsApp us on 065 377 8765, and we will confirm availability, pricing and how to complete your order.",
    link: { to: "/contact", label: "Send an enquiry" },
  },
  {
    q: "Do you offer delivery?",
    a: "Delivery and collection options are confirmed per order. Please contact us with your location and we will let you know what is available. Our delivery and returns policy is still being finalised.",
  },
  {
    q: "How can I enquire about prices?",
    a: "Prices are available on request. Use the “Enquire” button on any product, complete the contact form, or WhatsApp us and we will share current pricing.",
  },
  {
    q: "Where can I find ingredient information?",
    a: "Each product page has a product information section. We only publish ingredients, sizes and storage details once they have been verified against the actual packaging. Until then, please ask us and always read the label on your product.",
  },
  {
    q: "Can I subscribe for product updates?",
    a: "Yes. Join the Uhlumo Organics Community to receive product news and useful updates. You can unsubscribe at any time using the link in every email.",
  },
  {
    q: "How do I contact customer support?",
    a: "WhatsApp or call us on 065 377 8765, or email thozama@uhlumoorganics.co.za. Our hours are 09:00–18:00 (operating days to be confirmed).",
    link: { to: "/contact", label: "Contact us" },
  },
];

export const HOME_FAQS = GENERAL_FAQS.slice(0, 6);
